import { landingGearPositions } from './';

export const formatComponentSerial = (component = {}) =>
  component.label ? `${component.label}: ${component.serial}` : component.serial;

// Switching to Landing Gear adds LMLG / RMLG / NLG rows, keeping the values already entered.
export const addLandingGearPositions = (components = []) => {
  const existing = components.filter(item => item.label || item.serial);
  const missing = landingGearPositions
    .filter(position => !existing.find(item => (item.label || '').toUpperCase() === position))
    .map(position => ({ label: position, serial: '' }));
  return [...existing, ...missing];
};
